export const PARTIAL_OUT_OF_STOCK_MODAL_LOCATION = {
  checkout: 'checkout',
  cart: 'cart',
}
